import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

const LINKS = [
  { to: "/mentions-legales", label: "Mentions légales" },
  { to: "/cgu", label: "CGU / CGV" },
  { to: "/dpa", label: "DPA (RGPD)" },
  { to: "/confidentialite", label: "Confidentialité" },
];

export function LegalPage({ testid, kicker, title, updated, disclaimer, sections }) {
  return (
    <div className="min-h-screen bg-background" data-testid={testid}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground mb-6" data-testid={`${testid}-back-link`}>
          <ArrowLeft className="w-4 h-4" /> Retour
        </Link>
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-2xl bg-primary/10 flex items-center justify-center">
            <ShieldCheck className="w-6 h-6 text-primary" />
          </div>
          <div>
            <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{kicker}</p>
            <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight">{title}</h1>
          </div>
        </div>
        <p className="text-sm text-muted-foreground mt-4">{updated}</p>
        {disclaimer && (
          <div className="mt-4 rounded-xl border border-amber-300/50 bg-amber-50 dark:bg-amber-950/20 px-4 py-3 text-xs text-amber-800 dark:text-amber-300" data-testid={`${testid}-disclaimer`}>
            {disclaimer}
          </div>
        )}
        <div className="mt-8 space-y-6">
          {sections.map((s, i) => (
            <section key={i} data-testid={`${testid}-section-${i}`}>
              <h2 className="font-heading font-bold text-base">{s.h}</h2>
              <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed whitespace-pre-line">{s.p}</p>
            </section>
          ))}
        </div>
        <nav className="mt-10 pt-6 border-t flex flex-wrap gap-x-5 gap-y-2 text-xs text-muted-foreground">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="hover:text-foreground" data-testid={`legal-nav-${l.to.slice(1)}`}>{l.label}</Link>
          ))}
        </nav>
        <p className="text-xs text-muted-foreground mt-6">Contact : contact@kallitag.fr</p>
      </div>
    </div>
  );
}
